import * as React from "react";
import type { SVGProps } from "react";
const SvgSkiMaterial = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#ski-material_svg__a)">
      <g fill="currentColor" clipPath="url(#ski-material_svg__b)">
        <path d="M21 22a1 1 0 0 1-.71-.29l-4-4a1.003 1.003 0 1 1 1.42-1.42l4 4a.998.998 0 0 1-.326 1.636A1 1 0 0 1 21 22M7 8a1 1 0 0 1-.71-.29l-4-4a1.004 1.004 0 0 1 1.42-1.42l4 4A1 1 0 0 1 7 8" />
        <path d="M18.17 22a1 1 0 0 1-1.006-1 1 1 0 0 1 .296-.71l2.83-2.83a1.004 1.004 0 1 1 1.42 1.42l-2.83 2.83a1 1 0 0 1-.71.29M13 14a1 1 0 0 1-.71-.29l-2-2a1.004 1.004 0 0 1 1.42-1.42l2 2a.998.998 0 0 1-.326 1.636A1 1 0 0 1 13 14" />
        <path d="M16.27 2A5.9 5.9 0 0 1 15 4.68L3.71 16a1 1 0 0 1-1.639-.325 1 1 0 0 1 .219-1.095L13.61 3.27A5.8 5.8 0 0 1 16.27 2m.28-2a7.42 7.42 0 0 0-4.36 1.85L.88 13.17a3 3 0 0 0 0 4.24 3 3 0 0 0 4.24 0L16.44 6.1C17.61 4.92 19 1.61 17.85.44a1.8 1.8 0 0 0-1.3-.44" />
        <path d="M11.49 9.22a1 1 0 0 1-.71-.3L9.36 7.51a1 1 0 1 1 1.42-1.41l1.41 1.41a1 1 0 0 1 0 1.41 1 1 0 0 1-.7.3M8.66 12.05a1 1 0 0 1-.71-.3l-1.41-1.41a1 1 0 0 1 0-1.42 1 1 0 0 1 1.46 0l1.41 1.42a1 1 0 0 1 0 1.41 1 1 0 0 1-.75.3M21.93 7.68a6 6 0 0 1-1.25 2.66L9.36 21.65a1 1 0 0 1-1.41 0 1 1 0 0 1 0-1.41L19.26 8.92a5.9 5.9 0 0 1 2.67-1.24m.27-2a7.4 7.4 0 0 0-4.35 1.85L6.54 18.82a3 3 0 0 0 0 4.25 3 3 0 0 0 2.12.93 3 3 0 0 0 2.12-.88l11.31-11.37c1.17-1.17 2.59-4.48 1.42-5.65a1.8 1.8 0 0 0-1.31-.44z" />
        <path d="M17.14 14.87a1 1 0 0 1-.7-.29L15 13.17a1.004 1.004 0 1 1 1.42-1.42l1.41 1.42a1 1 0 0 1 0 1.41 1 1 0 0 1-.69.29M14.31 17.7a1 1 0 0 1-.7-.29L12.19 16a1.004 1.004 0 1 1 1.42-1.42L15 16a1 1 0 0 1 0 1.41 1 1 0 0 1-.69.29" />
      </g>
    </g>
    <defs>
      <clipPath id="ski-material_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="ski-material_svg__b">
        <path fill="#fff" d="M0 0h23.95v23.95H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSkiMaterial;
